const CONTENT_LENGTH = 'Content-Length';

async function getRemoteFileSize(url: string): Promise<number> {
  const res = await fetch(url, { method: 'HEAD' });
  return Number(res.headers?.get(CONTENT_LENGTH));
}

export default getRemoteFileSize;
